import { useFavoritesAuth } from '../contexts/FavoritesAuthContext'

/** Device-local favorites — gated behind login via FavoritesAuthProvider. */
export function useFavorites() {
  const { ids, has, toggle, remove, reconcileIds, count } = useFavoritesAuth()
  return { ids, has, toggle, remove, reconcileIds, count }
}
